(function(){
  var STORAGE_KEY = 'hiraf_lang';

  // Inject CSS to hide opposite lang
  function ensureStyle(){
    if(document.getElementById('hiraf-lang-style')) return;
    var s = document.createElement('style');
    s.id = 'hiraf-lang-style';
    s.textContent = 'html[lang="ar"] [data-lang="en"]{display:none!important}html[lang="en"] [data-lang="ar"]{display:none!important}';
    document.head.appendChild(s);
  }

  function applyLang(lang){
    ensureStyle();
    var html = document.documentElement;
    if(lang === 'en'){
      html.setAttribute('lang','en');
      html.setAttribute('dir','ltr');
      html.style.direction = 'ltr';
    } else {
      html.setAttribute('lang','ar');
      html.setAttribute('dir','rtl');
      html.style.direction = 'rtl';
    }
    // Clear any inline display styles we set, let CSS handle it
    document.querySelectorAll('[data-lang]').forEach(function(el){
      el.style.display = '';
    });
    // Update toggle button text
    var btn = document.getElementById('lang-toggle');
    if(btn) btn.textContent = (lang === 'ar') ? 'EN' : 'عربي';
    // Store preference
    try { localStorage.setItem(STORAGE_KEY, lang); } catch(e){}
  }

  function init(){
    ensureStyle();
    var saved = null;
    try { saved = localStorage.getItem(STORAGE_KEY); } catch(e){}
    if(saved === 'en' || saved === 'ar'){
      applyLang(saved);
    } else {
      applyLang('ar');
    }
  }

  window.toggleLang = function(){
    var current = document.documentElement.getAttribute('lang');
    applyLang(current === 'ar' ? 'en' : 'ar');
  };

  // Apply CSS ASAP (before DOMContentLoaded) to avoid flash
  if(document.head){
    ensureStyle();
    // Apply saved lang attribute on html immediately
    try {
      var s = localStorage.getItem(STORAGE_KEY);
      if(s === 'en' || s === 'ar'){
        document.documentElement.setAttribute('lang', s);
        document.documentElement.setAttribute('dir', s === 'en' ? 'ltr' : 'rtl');
      }
    } catch(e){}
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
